// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".subheader-card-col .subheader-card[data-v-afe7ccfe]{align-items:flex-start!important;display:flex!important;flex-direction:column!important}.subheader-card-card.subheader-card[data-v-afe7ccfe]{border-left:10px solid var(--v-cardBorder-base)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
